import React, { useState, useRef, useCallback } from 'react';
import { format } from 'date-fns';

import Button from '../Button';
import ProgressBar from '../ProgressBar';
import UploadedFile from './UploadedFile';
import { Heading2 } from '../Typography';
import { notify } from '../Notification';
import {
	Container,
	Column,
	UploadContainer,
	UploadsList,
	EmptyList,
	ProgressBarWrapper,
} from './styles';

import { FaCloudUploadAlt } from 'react-icons/fa';
import { uploadFiles } from '../../services/api';

const VoicesUploader = ({ modalRef, date, contract, neededOffs, onUploadSuccess }) => {
	const inputRef = useRef(null);

	const [uploadProgress, setUploadProgress] = useState(0);
	const [fallback, setFallback] = useState(false);
	const [files, setFiles] = useState([]);
	const [isUploading, setIsUploading] = useState(false);

	const handleInputChange = useCallback(
		(e) => {
			const files = [...e.target.files];

			console.log(files);

			if (files.length !== neededOffs) {
				inputRef.current.value = '';
				return notify('warn', `Selecione exatamente ${neededOffs} arquivos de áudio`);
			}

			const haveInvalidFile = files.some((file) => {
				const [, ext] = file.name.toLowerCase().split('.');
				return !['wav', 'mp3'].includes(ext);
			});

			if (haveInvalidFile) {
				inputRef.current.value = '';
				notify('warn', 'Um ou mais arquivos selecionados é inválido. Selecione .mp3 ou .wav');
				return;
			}

			setFiles(files);
			inputRef.current.value = '';
		},
		[neededOffs]
	);

	const renderList = useCallback(() => {
		if (!files.length) {
			return <EmptyList>Selecione os arquivos</EmptyList>;
		}

		return (
			<UploadsList>
				{files.map((file, index) => (
					<UploadedFile
						key={index}
						index={index}
						file={file}
						onRemoveFile={(index) => {
							setFiles((prev) => {
								const copy = [...prev];
								copy.splice(index, 1);
								return copy;
							});
						}}
					/>
				))}
			</UploadsList>
		);
	}, [files]);

	const handleSubmit = useCallback(async () => {
		try {
			if (files.length !== neededOffs) {
				return notify('warn', `Você precisa selecionar exatamente ${neededOffs} arquivos`);
			}

			setIsUploading(true);

			const formData = new FormData();
			const dateRelease = format(new Date(date), 'dd/MM/yyyy');

			formData.append('program', contract?.value?.program?._id);
			formData.append('dateRelease', dateRelease);
			files.forEach((uploadedFile) => formData.append('files', uploadedFile));

			await uploadFiles({
				formData,
				url: '/api/v2/offs',
				onProgress: (p) => setUploadProgress(p),
			});

			setFiles([]);
			onUploadSuccess();
			inputRef.current.value = '';
		} catch (error) {
			console.log(error);
			setFallback(false);
			notify('warn', error?.response?.data?.message);
		}
	}, [contract, date, files, neededOffs, onUploadSuccess]);

	return (
		<Container>
			<header>
				<Heading2>Subir Vozes</Heading2>
			</header>

			<div className='content'>
				<div className='upload-area'>
					<Column left>
						<UploadContainer htmlFor='offsInput' disabled={isUploading}>
							<FaCloudUploadAlt />

							<span>Clique aqui para subir os arquivos</span>
							<input
								id='offsInput'
								type='file'
								ref={inputRef}
								accept='audio/mp3'
								onChange={handleInputChange}
								multiple
							/>
						</UploadContainer>
					</Column>

					<Column right>{renderList()}</Column>
				</div>

				{isUploading && (
					<ProgressBarWrapper>
						<ProgressBar progress={uploadProgress} label='subindo offs...' />
					</ProgressBarWrapper>
				)}
			</div>

			{!uploadProgress && (
				<div className='buttons'>
					<Button
						color='#5f5f5f'
						variant='outlined'
						disabled={fallback}
						onClick={() => {
							setFiles([]);
							modalRef.current.close();
							inputRef.current.value = '';
						}}>
						Cancelar
					</Button>
					<Button color='success' onClick={handleSubmit} loading={fallback}>
						Enviar Vozes
					</Button>
				</div>
			)}
		</Container>
	);
};

export default VoicesUploader;
